import axios from 'axios'
import { getItem } from "@utils/localStorage"

export const apiUrl = process.env.REACT_APP_API_URL;

export const authInstance = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const instance = axios.create({
    baseURL: apiUrl,
    headers: { 'Content-Type': 'application/json' }
})

authInstance.interceptors.request.use(
    (config) => {
        const accessTokenString = getItem('access_token');
        if (accessTokenString) {
            try {
                const access_token = JSON.parse(accessTokenString);
                if (access_token) {
                    config.headers.Authorization = `Bearer ${access_token}`;
                }
            } catch (error) {
                console.error('Lỗi khi parse access_token từ localStorage:', error);
            }
        } else {
            console.error('Không tìm thấy access_token trong localStorage');
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

